import { ROLE_COMPETITOR_ANALYST, ROLE_ROUTING_TOOL_EDITOR, ROLE_WEB_EDITOR } from '@/util/constants'
import { ROLE_CMS_EDITOR } from '../util/constants'

class Auth {
  constructor () {
    let storage = window.localStorage
    Object.defineProperties(this, {
      storage: {
        get () {
          return storage
        }
      }
    })
  }

  getUser () {
    return JSON.parse(this.storage.getItem('user'))
  }

  setUser (payload) {
    var user = {
      id: payload.getEmail(),
      name: payload.getName(),
      email: payload.getEmail()
    }
    this.storage.setItem('user', JSON.stringify(user))
  }

  getAuth () {
    return JSON.parse(this.storage.getItem('auth'))
  }

  setAuth (payload) {
    this.storage.setItem('auth', JSON.stringify(payload))
  }

  isAuthenticated () {
    return this.getAuth() !== null && this.getUser() !== null && this.isAllowedToLogin()
  }

  getRoles (email) {
    const admin = this.getEmailsWithDomains([
      'webdev',
      'webteam',
      'andreas.gomm',
      'edison.harada',
      'johan.dahlqvist',
      'miguel.andrade',
      'oguzhan.duvenci',
      'svante.pagels',
      'bojan.mihailovic',
      'alper.baskir',
      'clade.lindstrom',
      'maxime.preaux',
      'regina.onorato',
      'himantha.perera',
      'daniel.martinez',
      'neal.bozeman'
    ])
    const roleWebEditorEmail = this.getEmailsWithDomains([
      'alexander.chau',
      'daniel.martinez',
      'kannan.balasubramanian',
      'puja.priya',
      'estela.corbellini',
      'jennifer.allam',
      'maja.zivkovic',
      'deandra.gracia',
      'clade.lindstrom',
      'matei.nicolae',
      'surya.rekha',
      'svante.pagels',
      'zahid.naqawi',
      'ezim.osai',
      'brett.vanzyl@rebtel.com',
      'danilo.draskovic',
      'jennifer.reyes',
      'mark.louie',
      'debora.diettrich',
      'regina.onorato',
      'himantha.perera',
      'quynh.tran'
    ])
    const roleCompetitorAnalyst = this.getEmailsWithDomains([
      'adnan.gohar',
      'cintia.regueiro',
      'cristina.mihai',
      'daniel.martinez',
      'kannan.balasubramanian',
      'puja.priya',
      'elena.chepkasova',
      'johan.granlund',
      'lanfranco.baffioni',
      'svante.pagels',
      'vasco.preto'
    ])
    const roleRoutingToolEditor = this.getEmailsWithDomains([
      'adnan.gohar',
      'cintia.regueiro',
      'cristina.mihai',
      'daniel.martinez',
      'kannan.balasubramanian',
      'puja.priya',
      'elena.chepkasova',
      'jennifer.allam',
      'johan.granlund',
      'lanfranco.baffioni',
      'maja.zivkovic',
      'deandra.gracia',
      'zahid.naqawi',
      'vasco.preto',
      'svante.pagels',
      'jennifer.reyes',
      'mark.louie',
      'debora.diettrich',
      'regina.onorato',
      'himantha.perera',
      'quynh.tran'
    ])
    const roleCmsEditor = this.getEmailsWithDomains([
      'svante.pagels',
      'anshula.kumar',
      'jennifer.allam',
      'maja.zivkovic',
      'deandra.gracia',
      'brett.vanzyl@rebtel.com',
      'kannan.balasubramanian',
      'debora.diettrich',
      'regina.onorato',
      'himantha.perera',
      'quynh.tran'
    ])

    const roles = []

    if (roleWebEditorEmail.indexOf(email) !== -1 || admin.indexOf(email) !== -1) {
      roles.push(ROLE_WEB_EDITOR)
    }

    if (roleCompetitorAnalyst.indexOf(email) !== -1 || admin.indexOf(email) !== -1) {
      roles.push(ROLE_COMPETITOR_ANALYST)
    }

    if (roleRoutingToolEditor.indexOf(email) !== -1 || admin.indexOf(email) !== -1) {
      roles.push(ROLE_ROUTING_TOOL_EDITOR)
    }

    if (roleCmsEditor.indexOf(email) !== -1 || admin.indexOf(email) !== -1) {
      roles.push(ROLE_CMS_EDITOR)
    }

    return roles
  }

  isAllowedToLogin () {
    var authorizedEmails = this.getEmailsWithDomains([
      'webdev',
      'webteam',
      'adnan.gohar',
      'alexander.chau',
      'andreas.gomm',
      'anshula.kumar',
      'cintia.regueiro',
      'clade.lindstrom',
      'cristina.mihai',
      'daniel.martinez',
      'edison.harada',
      'elena.chepkasova',
      'estela.corbellini',
      'jennifer.allam',
      'johan.dahlqvist',
      'johan.granlund',
      'kannan.balasubramanian',
      'lanfranco.baffioni',
      'maja.zivkovic',
      'deandra.gracia',
      'martin.hornqvist',
      'matei.nicolae',
      'miguel.andrade',
      'oguzhan.duvenci',
      'puja.priya',
      'surya.rekha',
      'svante.pagels',
      'vasco.preto',
      'zahid.naqawi',
      'ezim.osai',
      'bojan.mihailovic',
      'alper.baskir',
      'maxime.preaux',
      'danilo.draskovic',
      'jennifer.reyes',
      'mark.louie',
      'debora.diettrich',
      'regina.onorato',
      'himantha.perera',
      'quynh.tran',
      'neal.bozeman'
    ])

    return authorizedEmails.indexOf(this.getUser().email) !== -1
  }

  async authenticate (payload) {
    if (!'rebtel.com,majority.com'.includes(payload.googleUser.getHostedDomain())) {
      // eslint-disable-next-line no-throw-literal
      throw 'Invalid email!'
    }

    this.setUser(payload.googleUser.getBasicProfile())
    this.setAuth(payload.googleUser.getBasicProfile().getEmail())
  }

  logout () {
    this.storage.removeItem('auth')
    this.storage.removeItem('user')
  }

  getEmailsWithDomains (emails) {
    return emails.map(x => `${x}@rebtel.com`).join(emails.map(x => `${x}@majority.com`))
  }
}

export let auth = new Auth()



// WEBPACK FOOTER //
// ./src/services/auth.js